import Contaier from "../../components/layout/Container/Container";
import Footer from "../../components/molecules/Footer/Footer";
import LoginHeader from "../../components/molecules/Header/LoginHeader";

function NotFound() {
  return (
    <>
      <LoginHeader />
      <Contaier>
        <div className="inner-content">
          <div className="container">
            <div className="row">
              <div className="col-md-12 pt-5 pb-5">
                <h2>Looking for something?</h2>
              </div>
              <div className="col-md-12">
                <p>Looking for something? </p>
                <p>
                  Sorry, the page that you are looking for cannot be found.
                  Please check that you have keyed in the correct URL.
                </p>

                <p>
                  Please click <a href="/eservices">here </a>to return to our
                  homepage.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Contaier>
      <Footer />
    </>
  );
}

export default NotFound;
